import type { Dispatch, SetStateAction } from 'react';
import { BasketResponseError, ErrorCodeResponseError } from '../errors';
import type { ActiveBasketSummaryData } from '../typings/basket.types';
import { handleComponentError } from '.';
import type { Api } from '../api';
import type { ExpressWidgetError } from '../typings/error.types';

export const HandleGetActiveBasketSummary = async (
    API: Api,
    setExpressWidgetError: Dispatch<SetStateAction<ExpressWidgetError | null>>,
): Promise<ActiveBasketSummaryData | null> => {
    try {
        return await API.getActiveBasketSummary();
    } catch (error) {
        if (error instanceof ErrorCodeResponseError) {
            handleComponentError(new BasketResponseError(error.errorCode, error.message), setExpressWidgetError);
        } else {
            handleComponentError(error, setExpressWidgetError);
        }
    }
    return null;
};
